import { apiWrapper } from "@/services/api";

export const getQrInfoForQrTicketGate = async (id) => {
  let response;
  try {
    response = await apiWrapper("GET", `passes/${id}/qrcode_ticket`);
    return response.data;
  } catch (err) {
    console.log("ERROR!!! getQrInfoForQrTicketGate");
    throw err;
  }
};
